import React, { useCallback, useEffect, useMemo, useState } from 'react';

// import '@ant-design/compatible/assets/index.css';


import moment from 'moment';
import {
  message,
  Form,
  Tabs,
  Col,
  DatePicker,
  Input,
  Row,
  Radio,
  Checkbox,
  Typography,
  notification,
  Divider,
  Collapse,
} from 'antd';
import { isEmpty, sumBy } from 'lodash';

import DF from 'DisplayFramework';
import Text from 'components/Text';
import ParListSelect from 'components/ParListSelect';
import { Text as Textc } from '@react-pdf/renderer';
import { getProposalById, getProposalUsedAmounts } from 'services/proposal';
import { toCurrency, toRate } from 'utils/utils';
import AssetsTable from './AssetsTable';
import * as finEngine from 'services/finEngine';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import { groupBy } from '@antv/util';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { CaretRightOutlined } from '@ant-design/icons';
import InputRate from 'components/InputRate';
import RateFormulaSelect from 'components/RateFormulaSelect';
import FormInput from 'components/FormInput';
import InputCurrency from 'components/InputCurrency';
import { getMgParValueByParCode } from 'services/parametersService';

const { TabPane } = Tabs;
const { Text: AntText } = Typography;
const { Panel } = Collapse;

const TabAssetActivation = (props: any) => {
  props.form?.setFieldsValue({
    event: 'tabAssetActivation',
  });

  const { setSuccessful, form } = props;

  const [state, setState] = useState<any>({
    isLoading: false,
    conElemSteps: [],
    selectedRowKeys: [],
    SERV: [],
    FEES: [],
    COMM: [],
    FINSERV: [],
    ASSETLIST: [],
    ElementFIN: [],
    SERVELEM: [],
    rentalamountinit: 0,
    rentalamount: 0,
    investamountinit: 0,
    investamount: 0,
    upfrontamountinit: 0,
    upfrontamountused: 0,
    upfrontamount: 0,
    finamountinit: 0,
    finamountused: 0,
    finamount: 0,
    startdateinit: '',
    startdate: moment(),
    ctebillingdateinit: 1,
    ctebillingdate: 1,
    deferredinterestamount: 0,
    ctedeferredinterestmethod: '',
    ctedeferredinterestnominalrate: 0,
    ctedepositamountinit: 0,
    ctedepositamountused: 0,
    ctedepositamount: 0,
    ctedepositinterestmethod: '',
    ctedepositnominalrate: 0,
    firstrentalinit: 0,
    firstrentalcoef: 0,
    firstrentalamount: 0,
    residualvalueinit: 0,
    residualvalue: 0,
    rvcoef: 0,
    disbursmentinit: 0,
    disbursment: 0,
    commissioninit: 0,
    commission: 0,
    term: '',
    ratetype: '',
    rate: 0,
    rateperiodicity: '',
    periodicity: '',
    unit: '',
    duration: 0,
    durationlabel: '',
    interestmethod: '',
    gpduration: 0,
    gpmethod: '',
    ctepartmethod: '',
    ctepartrate: 0,
    ctepartnbdays: 0,
    partamountinit: 0,
    partamountused: 0,
    partamount: 0,
    issynd: false,
    taxtype: 'RENTAL',
    taxcode: 'NORM',
    taxrate: 20,
    currcode: localStorage.getItem('currcode') ?? '',
  });

  const initValues = useCallback(() => {
    props.form.setFieldsValue({
      invoiceParticipation: 'true',
      invoiceUpfront: 'true',
      invoiceDeferredinterest: 'true',
      invoiceDeposit: 'true',
      invoiceFirstrental: 'true',
      generateDisbursment: false,
      generateCommission: 'true',
      activationMode: 'FIN',
      deliveryDate: moment(),
    });
  }, [props.form]);

  const updateState = useCallback(
    (values) => {
      setState((prev: any) => ({ ...prev, ...values }));
    },
    [setState]
  );

  const [status, setStatus] = useState('ORDER');

  const loadTargetStatus = async () => {
    await getMgParValueByParCode({
      parcode: 'ASSETSPROP',
    })
      .then((response) => {
        if (response.data != null) {
          setStatus(response.data.parvaluemin ?? 'ORDER');
        } else {
          setStatus('ORDER');
        }
      })
      .catch((err) => {
        setStatus('ORDER');
      });
  };
  const loadCTDetail = useCallback(
    (ctrid) => {
      updateState({ isLoading: false });
      props.setSuccessful(true);

      getProposalById({ ctrid }).then((response) => {
        const proposal = response.data;

        props.form?.setFieldValue('ctfclevel', proposal?.ctfclevel);

        updateState({
          ctfclevel: proposal?.ctfclevel,
          flaguseassetgrossamount: proposal.flaguseassetgrossamount ?? false,
          prcode: proposal?.prcode
        });
        ////todo get conelements
        const {
          SERV = [],
          FEES = [],
          COMM = [],
          FINSERV = [],
        } = groupBy(proposal.conElements, 'ctetype');

        const elemFin = proposal.conElements.filter((e) => e.ctetype === 'FIN');

        updateState({
          SERV: SERV,
          FEES: FEES,
          COMM: COMM,
          FINSERV: FINSERV,
          conElemSteps: elemFin[0]!.conElemSteps,
          flaguseassetgrossamount: proposal.flaguseassetgrossamount ?? false,
        });
        const elemServ = proposal.conElements.filter(
          (e) => e.ctetype === 'SERV' || e.ctetype === 'FEES'
        );
        let SERVELEM: any = [];
        for (const el of elemServ) {
          const ell = el;
          SERVELEM = [...SERVELEM, ell.pricing];
        }
        updateState({
          SERVELEM,
          ElementFIN: elemFin,
          ASSETLIST: proposal.assets.map((asset) => ({
            ...asset,
            rentalpart: asset?.irvSchedule?.filter(
              (e) => e.ctstype === 'RENTAL'
            )[0]?.rentalpart,
          })),
        });

        initValues();

        props.form.setFieldsValue({
          prefinmethod: elemFin[0]?.prefinmethod,
          prefinbasis: elemFin[0]?.prefinbasis,
          prefinperiodicity: elemFin[0]?.prefinperiodicity,
          prefinnominalrate: elemFin[0]?.prefinnominalrate,
          prefinrateformula: elemFin[0]?.prefinrateformula,
          prefinratetype: elemFin[0]?.prefinratetype,
          flaguseassetgrossamount: proposal.flaguseassetgrossamount ?? false,
        });

        getProposalUsedAmounts({ ctrid }).then((response2) => {
          const usedAmounts = response2.data;
          props.form.setFieldsValue({
            upfrontAmount:
              sumBy(elemFin, 'cteupfrontamount') - usedAmounts?.upfrontused,
            participationAmount:
              sumBy(elemFin, 'ctepartamount') - usedAmounts?.partused,
            depositAmount:
              sumBy(elemFin, 'ctedepositamount') - usedAmounts?.depositused,
            investAmount: 0,
            finAmount: 0,
            residualValue: 0,
            startDate: moment(),
            billingDate: elemFin[0]!.ctebilligdate,
            ctduration: elemFin[0]!.cteduration,
            listAsset: '',
            deliveryReference: '',
          });

          updateState({
            isLoading: false,
            currcode: proposal.currcode,
            rentalamount: 0,
            rentalamountinit: sumBy(elemFin, 'cterentalamount'),
            term: elemFin[0]!.ctepaymentterm,
            ratetype: elemFin[0]!.cteratetype,
            rate: elemFin[0]!.ctenominalrate,
            rateperiodicity: elemFin[0]!.cterateperiodicity,
            periodicity: elemFin[0]!.cteperiodicity,
            unit: elemFin[0]!.cteunit,
            duration: elemFin[0]!.cteduration,
            interestmethod: elemFin[0]!.cteinterestmethod,
            investamountinit:
              proposal.cttype === 'PART' ||
              (proposal.cttype === 'LEAD' &&
                proposal.ctsyndinvoicingtype === 'SEPARATE')
                ? proposal.ctsyndmgpartamount
                : sumBy(elemFin, 'cteinvestamount'),
            issynd:
              proposal.cttype === 'PART' ||
              (proposal.cttype === 'LEAD' &&
                proposal.ctsyndinvoicingtype === 'SEPARATE'),
            investamount: 0,
            upfrontamountinit: sumBy(elemFin, 'cteupfrontamount'),
            upfrontamountused: usedAmounts?.upfrontused,
            upfrontamount:
              sumBy(elemFin, 'cteupfrontamount') - usedAmounts?.upfrontused,
            finamountinit: sumBy(elemFin, 'ctefinancedamount'),
            finamountused: usedAmounts?.finamountused,
            finamount: 0,
            startdateinit: elemFin[0]!.ctestartdate,
            startdate: moment(),
            ctebillingdateinit: elemFin[0]!.ctebilligdate,
            ctebillingdate: elemFin[0]!.ctebilligdate,
            deferredinterestamount: 0,
            ctedeferredinterestmethod: elemFin[0]!.ctedeferredinterestmethod,
            ctedeferredinterestnominalrate:
              elemFin[0]!.ctedeferredinterestnominalrate,
            deferredinterestlabel: elemFin[0]!.ctedeferredinterestmethodlabel,
            ctedepositamount:
              sumBy(elemFin, 'ctedepositamount') - usedAmounts?.depositused,
            ctedepositamountused: usedAmounts?.depositused,
            ctedepositinterestmethod: elemFin[0]!.ctedepositinterestmethod,
            ctedepositamountinit: sumBy(elemFin, 'ctedepositamount'),
            ctedepositnominalrate: elemFin[0]!.ctedepositnominalrate,
            firstrentalinit: sumBy(elemFin, 'ctefirstpayment'),
            firstrentalcoef: elemFin[0]!.ctefirstpaymentcoef,
            firstrentalamount: sumBy(elemFin, 'ctefirstpayment'),
            residualvalueinit: sumBy(elemFin, 'ctervamount'),
            residualvalue: 0,
            rvcoef: elemFin[0]!.ctervcoef,
            disbursmentinit: 0,
            disbursment: 0,
            commissioninit: 0,
            commission: 0,
            durationlabel: `${elemFin[0]!.cteduration} * ${
              elemFin[0]!.cteperiodicity
            } * ${elemFin[0]!.cteunitlabel}, ${
              elemFin[0]!.ctepaymenttermlabel
            }`,
            gpduration: elemFin[0]!.ctegraceperiodduration,
            gpmethod: elemFin[0]!.ctegraceperiodmethod,
            ctepartmethod: elemFin[0]!.ctepartmethod,
            ctepartrate: elemFin[0]!.ctepartrate,
            partamountinit: sumBy(elemFin, 'ctepartamount'),
            partamountused: usedAmounts?.partused,
            partamount: sumBy(elemFin, 'ctepartamount') - usedAmounts?.partused,
            taxtype: 'RENTAL',
            taxcode: elemFin[0]!.taxcode,
            taxrate: 20,
          });
        });
      });
    },
    [initValues, props.form, updateState]
  );
  const columnsconE = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        comcode: 'Element.ctetypelabel',
        dataIndex: 'servtypelabel',
        width: '20%',
        render: (value, record) =>
          record.serviceResponse?.servtypelabel ??
          record.commissionResponse?.commtypelabel,
      },
      {
        comcode: 'Element.servcategorylabel',
        dataIndex: 'servtypelabel',
        width: '20%',
        render: (value, record) =>
          record.serviceResponse?.servcategorylabel ?? record.ctecategory,
      },

      {
        comcode: 'Element.ctedescription',
        dataIndex: 'ctedescription',
        width: '30%',
      },
      {
        comcode: 'Element.tpname',
        dataIndex: 'tpname',
        width: '20%',
        render: (value, record) =>
          record.serviceResponse?.tpname ??
          record.commissionResponse?.commlabel,
      },
      {
        comcode: 'Element.servbasislabel',
        dataIndex: 'servbasislabel',
        width: '20%',
        render: (value, record) =>
          record.serviceResponse?.servbasislabel ??
          record.commissionResponse?.commbasislabel,
      },

      {
        comcode: 'Element.servcalculationmethodlabel',
        dataIndex: 'servcalculationmethodlabel',
        width: '35%',
        render: (value, record) =>
          record.serviceResponse?.servcalculationmethodlabel ??
          record.commissionResponse?.commcalculationmethodlabel,
      },

      {
        comcode: 'Element.servdurationlabel',
        dataIndex: 'servdurationlabel',
        width: '40%',
        render: (value, record) =>
          record.serviceResponse?.servdurationlabel ??
          record.commissionResponse?.commdurationlabel,
      },

      {
        comcode: 'Element.flagfollowgraceperiod',
        dataIndex: 'flagfollowgraceperiod',
        width: '20%',
        render: (value, record) => (
          <Textc>{String(record.pricing?.flagfollowgraceperiod)}</Textc>
        ),
      },

      {
        comcode: 'Element.flagmandatory',
        dataIndex: 'flagmandatory',
        width: '20%',
        render: (value, record) => (
          <Textc>{String(record.pricing?.flagmandatory)}</Textc>
        ),
      },
      {
        comcode: 'Element.flagupdate',
        dataIndex: 'flagupdate',
        width: '20%',
        render: (value, record) => (
          <Textc>{String(record.pricing?.flagupdate)}</Textc>
        ),
      },
      {
        comcode: 'Element.allowfinservice',
        dataIndex: 'allowfinservice',
        width: '20%',
        render: (value, record) => (
          <Textc>{String(record.pricing?.allowfinservice)}</Textc>
        ),
      },

      {
        comcode: 'Element.ctenominalrate',
        dataIndex: 'ctenominalrate',
        render: toRate,
        width: '20%',
      },
      {
        comcode: 'Element.cteinstallmentamount',
        dataIndex: 'cteinstallmentamount',
        render: (val) => toCurrency(val, state.currcode),
        fixed: 'right',
        width: '20%',
        align: 'right',
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );

  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        dataIndex: 'ctesorder',
        key: 'ctesorder',
        fixed: 'left',
        width: 120,
      },
      {
        dataIndex: 'ctesduration',
        key: 'ctesduration',
        width: 120,
      },

      {
        dataIndex: 'ctesperiodicity',
        key: 'ctesperiodicity',
        render: (value, record, index) => {
          return <ParListSelect value={value} parcode="PERIOD" disabled />;
        },

        width: 120,
      },

      {
        dataIndex: 'ctesperiodicityunit',
        key: 'ctesperiodicityunit',
        render: (value, record, index) => {
          return <ParListSelect value={value} parcode="UNIT" disabled />;
        },

        width: 120,
      },

      {
        dataIndex: 'ctesrentalcoef',
        key: 'ctesrentalcoef',
        render: (value, record, index) => toRate(value),
        width: 120,
      },

      {
        dataIndex: 'ctesrentalamount',
        key: 'ctesrentalamount',
        render: (value, record, index) => toCurrency(value, state.currcode),
        width: 120,
      },

      {
        dataIndex: 'ctesamortizedcoef',
        key: 'ctesamortizedcoef',
        render: (value, record, index) => toRate(value),
        width: 120,
      },

      {
        dataIndex: 'ctesoutstandingamount',
        key: 'ctesoutstandingamount',
        render: (value, record, index) => toCurrency(value, state.currcode),
        width: 120,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );

  const onChangeBilldate = (value: any) => {
    let elem = state.ElementFIN[0];

    calculate2(
      elem.ctecalculationtype,
      'INST',
      state.finamount,
      elem.ctepaymentterm,
      elem.cteinterestmethod,
      elem.ctenominalrate,
      elem.cterateperiodicity,
      elem.cteratetype,
      elem.cteunit,
      elem.cteperiodicity,
      elem.cteduration,
      state.residualvalue,
      elem.cteinstallmentamount,
      elem.cteratebasis,
      2,
      9,
      state.firstrentalamount,
      elem.ctegraceperiodduration,
      elem.ctegraceperiodmethod,
      value,
      elem.ctedeferredinterestmethod,
      elem.ctedeferredinterestnominalrate,
      elem.ctedepositinterestmethod,
      elem.ctedepositamount,
      elem.ctedepositnominalrate,
      elem.ctepartmethod,
      elem.ctepartamount,
      elem.ctepartrate,
      elem.ctepartnbdays,
      state.startdate,
      'RENTAL',
      elem.taxcode,
      0,
      state.upfrontamount
    );
  };

  const toDateString = (momentOrString: any) =>
    momentOrString === undefined
      ? ''
      : typeof momentOrString === 'string'
      ? momentOrString
      : momentOrString.format('YYYY-MM-DD');

  const calculate2 = (
    calctype:any,
    method: any,
    finamount: any,
    term: any,
    interestMethod: any,
    rate: any,
    ratePeriodicity: any,
    rateType: any,
    unit: any,
    periodicity: any,
    duration: any,
    RVAmount: any,
    installment: any,
    basis: any,
    rounding: any,
    roundingrate: any,
    firstrentalamount: any,
    gpduration: any,
    gpmethod: any,
    ctbillingdate: any,
    ctedeferredinterestmethod: any,
    ctedeferredinterestnominalrate: any,
    ctedepositinterestmethod: any,
    ctedepositamount: any,
    ctedepositnominalrate: any,
    ctepartmethod: any,
    ctepartamount: any,
    ctepartrate: any,
    ctepartnbdays: any,
    ctinitstartdate: any,
    taxtype: any,
    taxcode: any,
    taxrate: any,
    upfrontamount: any
  ) => {
    finEngine
      .calculate({
        finReq: {
          inBillingDate: ctbillingdate,
          inCalculationMethod: method,
          inCalculationType:calctype,
          inCountingbasis: basis,
          inDeferredMethod: ctedeferredinterestmethod,
          inDeferredRate: ctedeferredinterestnominalrate,
          inDepositAmount: ctedepositamount,
          inDepositMethod: ctedepositinterestmethod,
          inDepositRate: 0,
          inDuration: duration,
          inFinancedAmount: finamount,
          inFirstInstallmentDate: '',
          inFirstPayment: firstrentalamount,
          inGracePeriodDuration: gpduration,
          inGracePeriodMethod: gpmethod,
          inInstallmentAmount: installment,
          inInterestMethod: interestMethod,
          inPartAmount: ctepartamount,
          inPartMethod: ctepartmethod,
          inPartNbDays: ctepartnbdays,
          inPartRate: ctepartrate,
          inPeriodicity: periodicity,
          inPeriodicityUnit: unit,
          inRatePeriodicity: ratePeriodicity,
          inRateType: rateType,
          inRateValue: rate,
          inResidualValue: RVAmount,
          inRoundingAmount: rounding,
          inRoundingRate: roundingrate,
          inStartDate: toDateString(ctinitstartdate),
          inTaxcode: taxcode,
          inTaxrate: taxrate,
          inTaxtype: taxtype,
          inTerm: term,
          inUpFrontAmount: upfrontamount,
        },
      })
      .then((response) => {
        if (response.success === false) {
          notification.error({
            message: response.message,
            duration: 0,
          });
        } else {
          const calculations = response;
          const partAmount =
            ctepartmethod === 'PROMO' || ctepartmethod === 'REDUCEFIN'
              ? ctepartamount
              : 0;
          const upfrontAmount = upfrontamount;

          const investAmount = finamount + upfrontAmount + partAmount;

          props.form.setFieldsValue({
            investAmount: investAmount,

            finAmount: calculations.financedamount,
            residualValue: calculations.residualvalue,

            ctduration: calculations.duration,
          });

          updateState({
            deferredinterestamount: calculations.deferredInterest,
            residualvalue: calculations.residualvalue,
            duration: calculations.duration,
            finamount: calculations.financedamount,
            rentalamount:
              calculations.installmentamount - calculations.depositInterest,
          });

          const elemFin = state.ElementFIN;
          elemFin.cteinstallmentamount = calculations.installmentamount;
          elemFin.ctedeferredinterest = calculations.deferredInterest;
          elemFin.ctedepositinterest = calculations.depositInterest;
          elemFin.cterentalamount =
            calculations.installmentamount - calculations.depositInterest;
          elemFin.ctedeferredinterestmethod = ctedeferredinterestmethod;
          elemFin.ctedeferredinterestnominalrate =
            ctedeferredinterestnominalrate;
          elemFin.ctedepositamount = ctedepositamount;
          elemFin.ctedepositinterestmethod = ctedepositinterestmethod;
          elemFin.ctedepositnominalrate = ctedepositnominalrate;
          elemFin.ctepartmethod = ctepartmethod;
          elemFin.ctepartamount = ctepartamount;
          elemFin.ctepartrate = ctepartrate;
          elemFin.ctepartnbdays = ctepartnbdays;
          elemFin.taxcode = taxcode;
          elemFin.cteupfrontamount = state.upfront;
          elemFin.cteinvestamount = state.investamount;
          elemFin.ctenominalrate = calculations.nominalrate;
          elemFin.cteactuarialrate = calculations.effectiverate;
          elemFin.ctervamount = calculations.residualvalue;
          elemFin.ctervcoef =
            (calculations.residualvalue / calculations.financedamount) * 100;
          elemFin.ctefirstpayment = calculations.inFirstPayment;
          elemFin.ctefirstpaymentcoef =
            (calculations.inFirstPayment / calculations.financedamount) * 100;
          elemFin.cteduration = calculations.duration;
          elemFin.cteunit = unit;
          elemFin.ctefinancedamount = calculations.financedamount;
          elemFin.conElemSchedules = calculations.paymentSchedule;

          updateState({
            ElementFIN: elemFin,
          });
          //message.success(calculations.message);

          //applyPricingSERV2(state.SERVELEM, elemFin, unit);
        }
      })
      .catch((err) => {
        message.error(
          'Error in calculation. please contact the service provider'
        );
      });
  };

  const rowSelection = {
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      let total = 0;
      let listAsset = '';
      let totalRV = 0;
      let totalrental = 0;

      for (const i in selectedRows) {
        total += selectedRows[i].assetfinamount;

        totalrental += selectedRows[i].rentalpart;
        totalRV += selectedRows[i].assetrvamount;
        listAsset = selectedRows[i].assetid + `,` + listAsset;
      }

      if (state.ctfclevel === 'MOASSMUEL' || state.prcode ==='SPVAV') {
        total = state.investamountinit;
      }

      const coef = total / state.investamountinit;
      const upfrontamount = state.upfrontamountinit * coef;
      const partamount =
        state.ctepartmethod === 'FIXED' || state.ctepartmethod === 'POURC'
          ? 0
          : state.partamountinit * coef;
          

      const finamount = total - upfrontamount - partamount;

      const rvamount = totalRV;
      const firstrental = (state.firstrentalcoef * total) / 100;

      props.form.setFieldsValue({
        investAmount: total,
        finAmount: finamount,
        firstrental: firstrental,
        residualValue: rvamount,
        upfrontAmount: upfrontamount,
        participationAmount: state.partamountinit * coef,
        listAsset: listAsset ?? [],
      });

      setSuccessful(selectedRowKeys?.length > 0 ? false : true);

      updateState({
        selectedRowKeys,
        investamount: total,
        finamount,
        firstrentalamount: firstrental,
        residualvalue: rvamount,
        upfrontamount: upfrontamount,
        paramount: partamount,
        rentalamount: totalrental,
      });

      /*if (finamount > 0) {
        const rvcoef = (rvamount / finamount) * 100;
        calculate2(
          'INST',
          finamount,
          state.term,
          state.interestmethod,
          state.rate,
          state.rateperiodicity,
          state.ratetype,
          state.unit,
          state.periodicity,
          state.duration,
          rvamount,
          rvcoef,
          '360',
          2,
          9,
          firstrental,
          state.gpduration,
          state.gpmethod,
          state.ctebillingdate,
          state.ctedeferredinterestmethod,
          state.ctedeferredinterestnominalrate,
          state.ctedepositinterestmethod,
          state.ctedepositamount,
          state.ctedepositnominalrate,
          state.ctepartmethod,
          partamount,
          state.ctepartrate,
          state.ctepartnbdays,
          moment(state.startdate).format('YYYY-MM-DD'),
          state.taxtype,
          state.taxcode,
          state.taxrate,
          upfrontamount
        );
      }*/
    },
    getCheckboxProps: (record: any) => {
      return {
        disabled:
          record.assetstatus === status
            ? false
            : record.assetstatus === 'REMARK'
            ? false
            : true,

        name: record.assetstatuslabel,
      };
    },
  };

  useEffect(() => {
    loadCTDetail(props.objectid);
    loadTargetStatus();
  }, [props.objectid]);
  console.log({ state });
  return (
    <DF.Provider pagcode="tabassetactivation">
      <Form form={form} layout="horizontal" labelAlign="left">
        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => (
            <Tabs animated defaultActiveKey="1">
              <TabPane tab={<GetLabel label="Assets" />} key={1} forceRender>
                <Row gutter={16}>
                  <Col span={24}>
                    <Row>
                      <Col span={18}>
                        <FormInput
                          style={{ margin: 0 }}
                          name="activationMode"
                          comcode="finactivation"
                        >
                          <Radio.Group
                            defaultValue="FIN"
                            buttonStyle="solid"
                            onChange={() => {
                              props?.form.setFieldValue(
                                'investamount',
                                state.investamount
                              );
                            }}
                          >
                            <Radio.Button value="NO">No</Radio.Button>
                            <Radio.Button value="FIN">
                              <GetLabel label="finElement" />
                            </Radio.Button>
                            <Radio.Button value="PREFIN">
                              <GetLabel label="preFin" />
                            </Radio.Button>
                          </Radio.Group>
                        </FormInput>
                      </Col>

                      <Col span={6} style={{ textAlign: 'right' }}>
                        <AntText type="warning">
                          <GetLabel label="totalAssets" /> :
                          {toCurrency(state.investamountinit, state.currcode)}
                        </AntText>
                        <br />
                        <AntText type="danger">
                          <GetLabel label="totalSelected" /> :{' '}
                          {toCurrency(state.investamount, state.currcode)}
                        </AntText>
                        <br />
                      </Col>
                    </Row>

                    <Row gutter={16}>
                      <Col span={4}>
                        <FormInput
                          style={{ margin: 0 }}
                          name="deliveryDate"
                          comcode="deliveryDate"
                        >
                          <DatePicker showToday />
                        </FormInput>
                      </Col>
                      <Col span={10}>
                        <FormInput
                          col
                          xs={12}
                          name="deliveryReference"
                          comcode="deliveryReference"
                          rules={[{ required: true }]}
                        />
                      </Col>
                    </Row>
                    <FormInput
                      style={{ margin: 0 }}
                      name="listAsset"
                      rules={[
                        {
                          validator() {
                            if (isEmpty(state.selectedRowKeys)) {
                              return Promise.reject(
                                new Error('No Asset Selected')
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                      col
                      xs={24}
                      comcode="listAsset"
                    >
                      <Input value={state.selectedRowKeys} hidden />
                    </FormInput>
                    <AssetsTable
                      currcode={state.currcode}
                      isLoading={state.isLoading}
                      size="small"
                      scroll={{ x: 1000, y: 250 }}
                      pagination={{ pageSize: 100 }}
                      rowSelection={{
                        type: 'checkbox',
                        ...rowSelection,
                      }}
                      dataSource={state.ASSETLIST}
                      rowKey={(record) => record.assetid}
                      status={status}
                    />
                  </Col>
                </Row>
              </TabPane>

              {getFieldValue('activationMode') === 'PREFIN' && (
                <TabPane
                  tab={<GetLabel label="prefinActivation" />}
                  key={2}
                  forceRender
                >
                  <Row gutter={10} style={{ fontWeight: 'bold' }}>
                    <Col span={8}>
                      <Text comcode="finattribute" />
                    </Col>
                    <Col span={4}>
                      <Text comcode="initial" />
                    </Col>
                    <Col span={4}>
                      <Text comcode="alreadyAct" />
                    </Col>
                    <Col span={3}>
                      <Text comcode="toActivate" />
                    </Col>
                    <Col span={5} />
                  </Row>

                  <Row gutter={10}>
                    <Col span={8}>
                      <Text comcode="investamount" />
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="investAmountinit">
                        <AntText>
                          {toCurrency(state.investamountinit, state.currcode)}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4}></Col>
                    <Col span={3}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="investAmount"
                        initialValue={state.investamount}
                        wrapperCol={{ span: 23 }}
                      >
                        <InputCurrency
                          disabled
                          formatter={(value) => toCurrency(value)}
                          currcode={localStorage.getItem('currcode') ?? ''}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={3}>
                      <FormInput
                        style={{ margin: 0 }}
                        name="generateDisbursment"
                        noStyle
                      >
                        <Checkbox
                          onChange={(a) => {
                            props?.form.setFieldValue(
                              'generateDisbursment',
                              a.target.checked
                            );
                          }}
                        >
                          <Text comcode="generateDisbursment" />
                        </Checkbox>
                      </FormInput>
                    </Col>
                  </Row>

                  <Row gutter={10}>
                    <Col span={8}>
                      <Text comcode="upfrontamount" />
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="upfrontamountinit">
                        <AntText>
                          {toCurrency(state.upfrontamountinit, state.currcode)}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="upfrontamountused">
                        <AntText>
                          {toCurrency(state.upfrontamountused, state.currcode)}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={3}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="upfrontAmount"
                        wrapperCol={{ span: 23 }}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={5}>
                      <Form.Item style={{ margin: 0 }} name="invoiceUpfront">
                        <Checkbox defaultChecked>
                          <Text comcode="flagupfront" />
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={10}>
                    <Col span={8}>
                      <Text comcode="residualvalue" />
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="residualvalueinit">
                        <AntText strong>
                          {toCurrency(state.residualvalueinit, state.currcode)}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={3}>
                      <Form.Item style={{ margin: 0 }} name="residualValue">
                        <AntText strong type="warning">
                          {toCurrency(state.residualvalue, state.currcode)}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={5} />
                  </Row>

                  <Divider></Divider>

                  <Row gutter={10}>
                    <FormInput
                      col
                      md={7}
                      style={{ margin: 0 }}
                      name="startdateinit"
                      comcode="startdate"
                      wrapperCol={{ span: 16 }}
                      labelAlign="left"
                      labelCol={{ span: 8 }}
                    >
                      <AntText>{state.startdateinit}</AntText>
                    </FormInput>
                    <Col span={7}>
                      <FormInput
                        style={{ margin: 0 }}
                        name="startDate"
                        wrapperCol={{ span: 16 }}
                        labelAlign="left"
                        labelCol={{ span: 8 }}
                      >
                        <DatePicker />
                      </FormInput>
                    </Col>
                  </Row>

                  <Row gutter={10}>
                    <Col span={7}>
                      <Form.Item
                        name="prefinmethod"
                        shouldUpdate={() => true}
                        noStyle
                      >
                        <FormInput
                          name="prefinmethod"
                          initialValue={state.ElementFIN[0]?.prefinmethod}
                          wrapperCol={{ span: 16 }}
                          labelAlign="left"
                          labelCol={{ span: 8 }}
                        >
                          <ParListSelect
                            parcode="PREFINMET"
                            // parvalueparent={getFieldValue('prefinmethod')}
                          />
                        </FormInput>
                      </Form.Item>
                    </Col>

                    <Col span={7}>
                      <FormInput
                        name="prefinbasis"
                        initialValue={state.ElementFIN[0]?.prefinbasis}
                        wrapperCol={{ span: 16 }}
                        labelAlign="left"
                        labelCol={{ span: 8 }}
                      >
                        <ParListSelect parcode="PREFINBAS" />
                      </FormInput>
                    </Col>
                    <Col span={7}>
                      <FormInput
                        name="prefinperiodicity"
                        initialValue={state.ElementFIN[0]?.prefinperiodicity}
                        wrapperCol={{ span: 16 }}
                        labelAlign="left"
                        labelCol={{ span: 8 }}
                      >
                        <ParListSelect
                          parcode="PREFINPER"
                          // parvalueparent={getFieldValue('prefinperiodicity')}
                        />
                      </FormInput>
                    </Col>
                  </Row>
                  <Row gutter={10}>
                    <Col span={7}>
                      <FormInput
                        name="prefinratetype"
                        initialValue={state.ElementFIN[0]?.prefinratetype}
                        wrapperCol={{ span: 16 }}
                        labelAlign="left"
                        labelCol={{ span: 8 }}
                      >
                        <ParListSelect parcode="RATETYPE" />
                      </FormInput>
                    </Col>
                    <Col span={7}>
                      <Form.Item shouldUpdate={() => true} noStyle>
                        {({ getFieldValue }) => {
                          return (
                            <FormInput
                              name="prefinrateformula"
                              initialValue={
                                state.ElementFIN[0]?.prefinrateformula
                              }
                              wrapperCol={{ span: 16 }}
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                            >
                              <RateFormulaSelect
                                params={{
                                  formulatype: getFieldValue('prefinratetype'),
                                }}
                              />
                            </FormInput>
                          );
                        }}
                      </Form.Item>
                    </Col>

                    <Col span={7}>
                      <FormInput
                        name="prefinnominalrate"
                        initialValue={state.ElementFIN[0]?.prefinnominalrate}
                        wrapperCol={{ span: 16 }}
                        labelAlign="left"
                        labelCol={{ span: 8 }}
                      >
                        <InputRate />
                      </FormInput>
                    </Col>
                  </Row>
                </TabPane>
              )}

              {getFieldValue('activationMode') === 'FIN' && (
                <TabPane
                  tab={<GetLabel label="finActivation" />}
                  key={3}
                  forceRender
                >
                  <Row gutter={[8, 8]} style={{ fontWeight: 'bold' }}>
                    <Col span={8}>
                      <Text comcode="finattribute" />
                    </Col>
                    <Col span={4}>
                      <Text comcode="initial" />
                    </Col>
                    <Col span={4}>
                      <Text comcode="alreadyAct" />
                    </Col>
                    <Col span={4}>
                      <Text comcode="toActivate" />
                    </Col>
                    <Col span={4} />
                  </Row>

                  <Row gutter={[8, 8]}>
                    <Col span={8}>
                      <Text comcode="investamount" />
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="investAmountinit">
                        <AntText>
                          {toCurrency(state.investamountinit, state.currcode)}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4}></Col>
                    <Col span={4}>
                      {state.issynd ? (
                        <Form.Item style={{ margin: 0 }} name="investAmount">
                          <AntText>
                            {toCurrency(state.investamountinit, state.currcode)}
                            {/* rentalamount? */}
                          </AntText>
                        </Form.Item>
                      ) : (
                        <Form.Item
                          style={{ margin: 0 }}
                          name="investAmount"
                          initialValue={state.investAmount}
                          wrapperCol={{ span: 23 }}
                        >
                          <InputCurrency currcode={state.currcode} disabled />
                        </Form.Item>
                      )}
                    </Col>
                  </Row>

                  <Row gutter={[8, 8]}>
                    <Col span={8}>
                      <Text comcode="upfrontamount" />
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="upfrontamountinit">
                        <AntText>
                          {toCurrency(state.upfrontamountinit, state.currcode)}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="upfrontamountused">
                        <AntText>
                          {toCurrency(state.upfrontamountused, state.currcode)}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item
                        style={{ margin: 0 }}
                        wrapperCol={{ span: 23 }}
                        name="upfrontAmount"
                      >
                        <InputCurrency currcode={state.currcode} disabled />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="invoiceUpfront">
                        <Checkbox defaultChecked>
                          <Text comcode="flagupfront" />
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[8, 8]}>
                    <Col span={8}>
                      <Text comcode="partamount" />
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="partamountinit">
                        <AntText>
                          {toCurrency(state.partamountinit, state.currcode)}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="partamountused">
                        <AntText>
                          {toCurrency(state.partamountused, state.currcode)}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="participationAmount"
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="invoiceParticipation"
                      >
                        <Checkbox defaultChecked>
                          <Text comcode="flagpart" />
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[8, 8]}>
                    <Col span={8}>
                      <Text comcode="finamount" />
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="finamountinit">
                        <AntText>
                          {toCurrency(state.finamountinit, state.currcode)}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="finamountused">
                        <AntText>
                          {toCurrency(state.finamountused, state.currcode)}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="finAmount">
                        <AntText>
                          {toCurrency(state.finamount, state.currcode)}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4} />
                  </Row>

                  <Row gutter={[8, 8]}>
                    <Col span={8}>
                      <Text comcode="startdate" />
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="startdateinit">
                        <AntText>{state.startdateinit}</AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4} />
                    <Col span={4}>
                      <FormInput
                        style={{ margin: 0 }}
                        name="startDate"
                        wrapperCol={{ span: 23 }}
                      >
                        <DatePicker />
                      </FormInput>
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="ctduration">
                        <AntText type="danger">{state.durationlabel}</AntText>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[8, 8]}>
                    <Col span={8}>
                      <Text comcode="billingdate" />
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="billingdateinit">
                        <AntText>{state.ctebillingdateinit}</AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4} />
                    <Col span={4}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="billingDate"
                        wrapperCol={{ span: 23 }}
                      >
                        <ParListSelect
                          parcode="BILLDATE"
                          onChange={onChangeBilldate}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col span={4} />
                  </Row>

                  <Row gutter={[8, 8]}>
                    <Col span={8}>
                      <Text comcode="deferredinterest" />
                    </Col>
                    <Col span={4}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="ctedeferredinterestmethod"
                      >
                        <AntText>{state.deferredinterestlabel}</AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="ctedeferredinterestnominalrate"
                      >
                        <AntText>
                          {state.ctedeferredinterestnominalrate}%
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="deferredinterestamount"
                      >
                        <AntText>
                          {toCurrency(
                            state.deferredinterestamount,
                            state.currcode
                          )}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="invoiceDeferredinterest"
                      >
                        <Checkbox defaultChecked>
                          <Text comcode="flagdeferredinterest" />
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[8, 8]}>
                    <Col span={8}>
                      <Text comcode="deposit" />
                    </Col>
                    <Col span={4}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="ctedepositamountinit"
                      >
                        <AntText>
                          {toCurrency(
                            state.ctedepositamountinit,
                            state.currcode
                          )}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="ctedepositamountused"
                      >
                        <AntText>
                          {toCurrency(
                            state.ctedepositamountused,
                            state.currcode
                          )}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="depositAmount">
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="invoiceDeposit">
                        <Checkbox defaultChecked>
                          <Text comcode="flagdeposit" />
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[8, 8]}>
                    <Col span={8}>
                      <Text comcode="firstrental" />
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="firstrentalinit">
                        <AntText strong>
                          {toCurrency(state.firstrentalinit, state.currcode)}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4} />
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="firstrental">
                        <AntText strong type="warning">
                          {toCurrency(state.firstrentalamount, state.currcode)}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item
                        style={{ margin: 0 }}
                        name="invoiceFirstrental"
                      >
                        <Checkbox defaultChecked>
                          <Text comcode="flagfirstrental" />
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>
                  {state.conElemSteps.length === 0 && (
                    <Row gutter={[8, 8]}>
                      <Col span={8}>
                        <Text comcode="Rental" />
                      </Col>
                      <Col span={4}>
                        <Form.Item
                          style={{ margin: 0 }}
                          name="rentalamountinit"
                        >
                          <AntText strong>
                            {toCurrency(state.rentalamountinit, state.currcode)}
                          </AntText>
                        </Form.Item>
                      </Col>
                      <Col span={4} />
                      <Col span={4}>
                        <Form.Item style={{ margin: 0 }} name="rentalamount">
                          <AntText strong type="warning">
                            {toCurrency(state.rentalamount, state.currcode)}
                          </AntText>
                        </Form.Item>
                      </Col>
                      <Col span={4} />
                    </Row>
                  )}

                  <Row gutter={[8, 8]}>
                    <Col span={8}>
                      <Text comcode="residualvalue" />
                    </Col>
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="residualvalueinit">
                        <AntText strong>
                          {toCurrency(state.residualvalueinit, state.currcode)}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4} />
                    <Col span={4}>
                      <Form.Item style={{ margin: 0 }} name="residualValue">
                        <AntText strong type="warning">
                          {toCurrency(state.residualvalue, state.currcode)}
                        </AntText>
                      </Form.Item>
                    </Col>
                    <Col span={4} />
                  </Row>

                  {state.conElemSteps.length !== 0 && (
                    <DataGrid
                      rowKey="cteid"
                      dataSource={state.conElemSteps}
                      titleComcode="steps"
                      columns={columns}
                    />
                  )}
                </TabPane>
              )}
              <TabPane tab={<GetLabel label="elements" />} key={4} forceRender>
                <Collapse
                  bordered={false}
                  defaultActiveKey={['1']}
                  expandIcon={({ isActive }) => (
                    <CaretRightOutlined
                      style={{ fontSize: 24 }}
                      rotate={isActive ? 90 : 0}
                    />
                  )}
                  expandIconPosition="left"
                >
                  {state.SERV.length !== 0 && (
                    <Panel
                      header={
                        <Textc style={{ fontSize: 22, fontWeight: 'bold' }}>
                          <GetLabel label="SERV" />
                        </Textc>
                      }
                      key="1"
                      style={{
                        marginBottom: 24,
                        overflow: 'hidden',
                        background: '#f7f7f7',
                        border: 10,
                        borderRadius: 2,
                      }}
                    >
                      <DataGrid
                        rowKey="cteid"
                        dataSource={state.SERV}
                        columns={columnsconE}
                      />
                    </Panel>
                  )}
                  {state.FEES.length !== 0 && (
                    <Panel
                      header={
                        <Textc style={{ fontSize: 22, fontWeight: 'bold' }}>
                          <GetLabel label="FEES" />
                        </Textc>
                      }
                      key="2"
                      style={{
                        marginBottom: 24,
                        overflow: 'hidden',
                        background: '#f7f7f7',
                        border: 10,
                        borderRadius: 2,
                      }}
                    >
                      <DataGrid
                        rowKey="cteid"
                        dataSource={state.FEES}
                        columns={columnsconE}
                      />
                    </Panel>
                  )}
                  {state.FINSERV.length !== 0 && (
                    <Panel
                      header={
                        <Textc style={{ fontSize: 22, fontWeight: 'bold' }}>
                          <GetLabel label="FINSERV" />
                        </Textc>
                      }
                      key="3"
                      style={{
                        marginBottom: 24,
                        overflow: 'hidden',
                        background: '#f7f7f7',
                        border: 10,
                        borderRadius: 2,
                      }}
                    >
                      <DataGrid
                        rowKey="cteid"
                        dataSource={state.FINSERV}
                        columns={columnsconE}
                      />
                    </Panel>
                  )}
                  {state.COMM.length !== 0 && (
                    <Panel
                      header={
                        <Textc style={{ fontSize: 22, fontWeight: 'bold' }}>
                          <GetLabel label="COMM" />
                        </Textc>
                      }
                      key="4"
                      style={{
                        marginBottom: 24,
                        overflow: 'hidden',
                        background: '#f7f7f7',
                        border: 10,
                        borderRadius: 2,
                      }}
                    >
                      <DataGrid
                        rowKey="cteid"
                        dataSource={state.COMM}
                        columns={columnsconE}
                      />
                    </Panel>
                  )}
                </Collapse>
              </TabPane>
            </Tabs>
          )}
        </Form.Item>
      </Form>
    </DF.Provider>
  );
};
export default TabAssetActivation;
